import { erpAxios } from '..';

const editSuduznik = async (data) => {
  const res = await erpAxios.post(`/suduznici/edit`, data);
  return res;
};

export default editSuduznik;
